import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import exchangePhoto from "../../../assets/images/exchange.svg";
import { dateForm, getDropLocation, getPicLocation } from "../../../helpers.js";
import {
  addBusName,
  regularBookingInformation,
  SearchInfoStore,
  updateFareSummery,
  setJourneyDepartureDate,
} from "../../../redux/action/busAction.js";
import {
  Form,
  InnerForm,
  InputsRow,
  Location,
  DateContainer,
  InputGroup,
  InputLabel,
  Calendar,
  SearchLocation,
  SearchBtnArea,
  SearchBtn,
  ExchangeButton,
  TabContainer,
  TabItem,
  TrendingWrapper,
  BookingPageInnerForm,
  BookingPageLocation,
  BookingPageDate,
  BookingPageSearchBtn,
} from "./SearchFrom.styles.js";

// Inline Icons for Premium Look
const BusIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM18 10H6V6h12v4z"/>
  </svg>
);

const ShipIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.64 2.62.99 4 .99h2v-2h-2zM3.93 11.5L2 14h18l-1.93-2.5c-.19-.25-.49-.4-.81-.4h-.26V9h.5c.55 0 1-.45 1-1s-.45-1-1-1h-6.5V3.5c0-.83-.67-1.5-1.5-1.5S9.5 2.67 9.5 3.5V7H6c-.55 0-1 .45-1 1s.45 1 1 1h.5v2.1h-.26c-.32 0-.62.15-.81.4z"/>
  </svg>
);

const FlightIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

const SearchForm = ({ locationRef, searchInfo, setFilterBus }) => {
  const { webSettingData, languageData } = useSelector(
    (state) => state.busLists
  );

  const [location, setLocation] = useState([]);
  const [journeyStartDate, setJourneyStartDate] = useState("");
  const [journeyReturnDate, setJourneyReturnDate] = useState("");
  const [activeTab, setActiveTab] = useState("bus");
  
  const history = useHistory();
  const isHome = history?.location?.pathname !== "/";
  const dispatch = useDispatch();

  const reloadSubmit = async (info) => {
    const formData = new FormData();

    formData.append("pick_location_id", info?.pickLocation);
    formData.append("drop_location_id", info?.dropLocation);
    formData.append("journeydate", dateForm(info?.journeydate));
    if (info?.returnDate === "NaN-NaN-NaN") {
      formData.append("returnDate", "");
    } else {
      formData.append("returnDate", dateForm(info?.returnDate));
    }

    const searchInfo = {
      pickLocation: info?.pickLocation,
      dropLocation: info?.dropLocation,
      journeydate: dateForm(journeyStartDate),
      returnDate: dateForm(journeyReturnDate),
    };

    dispatch(SearchInfoStore(searchInfo));

    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/triplist`,
      {
        method: "POST",
        body: formData,
      }
    );
    const result = await response.json();

    if (result.status === "success") {
      dispatch(addBusName(result.data));
      setFilterBus(result.data);
    } else {
      dispatch(addBusName(null));
    }
  };

  const startJourneyDateHandler = (date) => {
    setJourneyStartDate(date);
  };

  const returnJourneyDateHandler = (date) => {
    setJourneyReturnDate(date);
  };

  const cursorStyles = {
    option: (styles, state) => {
      return {
        ...styles,
        cursor: "pointer",
        backgroundColor: state.isSelected 
          ? (webSettingData?.buttoncolor || "#1FBA30") 
          : state.isFocused 
            ? "#f1f5f9" 
            : "white",
        color: state.isSelected ? "white" : "#1e293b",
        fontWeight: "600",
        padding: "10px 15px",
        ":active": {
          backgroundColor: webSettingData?.buttoncolor || "#1FBA30",
          color: "white"
        }
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        backgroundColor: "white",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        border: "1px solid #eef2f6",
        borderRadius: "8px",
        zIndex: 9999,
        position: "absolute"
      };
    },
    menuList: (styles) => {
      return {
        ...styles,
        padding: "4px",
      };
    }
  };

  const locationData = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/locations`
    );
    const result = await response.json();
    setLocation(result.data);

    let locations = [];

    result?.data?.map((item) =>
      locations.push({
        value: item?.name,
        label: item?.name,
        id: item?.id,
      })
    );

    setPickLocation(locations);
    setDropLocation(locations);
  };
  let locations = [];

  if (Array.isArray(location)) {
    location.forEach((item) => {
      locations.push({
        value: item?.name,
        label: item?.name,
        id: item?.id,
      });
    });
  } else {
    console.error("location is not an array:", location);
  }

  const [values, setValues] = useState({
    drop_location: searchInfo?.dropLocation,
    pick_location: searchInfo?.pickLocation,
  });

  const [pickLocation, setPickLocation] = useState([]);
  const [dropLocation, setDropLocation] = useState([]);

  useEffect(() => {
    setValues({
      ...values,
      drop_location: searchInfo?.dropLocation,
      pick_location: searchInfo?.pickLocation,
    });
  }, [searchInfo]);

  useEffect(() => {
    try {
      locationData();
      return () => {
        setLocation({});
      };
    } catch (error) {
      console.log("searchForm error", error);
    }
  }, []);

  const handleBoardingChange = (selectOption) => {
    setValues({ ...values, pick_location: selectOption.id });

    const searchData = {
      dropLocation: searchInfo?.dropLocation,
      journeydate: searchInfo?.journeydate,
      pickLocation: selectOption.id,
      returnDate: searchInfo?.returnDate,
    };

    localStorage.setItem("searchInfo", JSON.stringify(searchData));

    let updateLoc = [];
    for (var i = 0; i < location.length; i++) {
      if (selectOption.id == location[i]?.id) {
      } else {
        updateLoc.push({
          value: location[i]?.name,
          label: location[i]?.name,
          id: location[i]?.id,
        });
      }
    }
    setDropLocation(updateLoc);
  };

  const handleDroppingChange = (selectOption) => {
    setValues({ ...values, drop_location: selectOption.id });

    const searchData = {
      dropLocation: selectOption.id,
      journeydate: searchInfo?.journeydate,
      pickLocation: searchInfo?.pickLocation,
      returnDate: searchInfo?.returnDate,
    };

    localStorage.setItem("searchInfo", JSON.stringify(searchData));

    let updateLoc = [];
    for (var i = 0; i < location.length; i++) {
      if (selectOption.id == location[i]?.id) {
      } else {
        updateLoc.push({
          value: location[i]?.name,
          label: location[i]?.name,
          id: location[i]?.id,
        });
      }
    }
    setPickLocation(updateLoc);
  };

  const handleExchange = () => {
    if (values.pick_location && values.drop_location) {
      setValues({
        pick_location: values.drop_location,
        drop_location: values.pick_location,
      });
    }
  };

  const handleTrendingSearch = async (fromName, toName) => {
    if (!Array.isArray(location) || location.length === 0) {
      toast.error("Locations are still loading. Please try again in a moment.");
      return;
    }
    const fromLoc = location.find(l => l && l.name && l.name.toLowerCase().includes(fromName.toLowerCase()));
    const toLoc = location.find(l => l && l.name && l.name.toLowerCase().includes(toName.toLowerCase()));
    
    if (fromLoc && toLoc) {
      setValues({
        pick_location: fromLoc.id,
        drop_location: toLoc.id,
      });

      dispatch(regularBookingInformation(" "));
      dispatch(updateFareSummery(null));
      localStorage.removeItem("bookingInfo");
      localStorage.removeItem("returnFirstJourneyInfo");
      localStorage.removeItem("journeyInfo");
      localStorage.removeItem("discount");
      localStorage.removeItem("regular");
      localStorage.removeItem("return");
      localStorage.removeItem("bookingInfoTax");
      localStorage.removeItem("journeyInfoTax");
      localStorage.removeItem("subtripId");
      localStorage.removeItem("passengerInformation");

      const dateStr = dateForm(journeyStartDate || new window.Date());
      const searchInfoData = {
        pickLocation: fromLoc.id,
        dropLocation: toLoc.id,
        journeydate: dateStr,
        returnDate: "",
      };

      dispatch(SearchInfoStore(searchInfoData));
      dispatch(setJourneyDepartureDate(journeyStartDate || new window.Date()));
      localStorage.setItem("searchInfo", JSON.stringify(searchInfoData));

      const formData = new FormData();
      formData.append("pick_location_id", fromLoc.id);
      formData.append("drop_location_id", toLoc.id);
      formData.append("journeydate", dateStr);

      toast.info(`Searching: ${fromLoc.name} to ${toLoc.name}`);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_MODULE_DOMAIN}/triplist`,
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();

        if (result.status === "success") {
          dispatch(addBusName(result.data));
          setFilterBus(result.data);
          history.push("/booking");
        } else {
          dispatch(addBusName(null));
          toast.error(result?.message || "No buses found for this trending route.");
        }
      } catch (error) {
        toast.error("Error fetching trending search results.");
      }
    } else {
      toast.error(`Route ${fromName} to ${toName} is currently unavailable.`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Remove all old local storage data
    dispatch(regularBookingInformation(" "));
    dispatch(updateFareSummery(null));
    localStorage.removeItem("bookingInfo");
    localStorage.removeItem("searchInfo");
    localStorage.removeItem("returnFirstJourneyInfo");
    localStorage.removeItem("journeyInfo");

    localStorage.removeItem("discount");
    localStorage.removeItem("regular");
    localStorage.removeItem("return");
    localStorage.removeItem("bookingInfoTax");
    localStorage.removeItem("journeyInfoTax");
    localStorage.removeItem("subtripId");
    localStorage.removeItem("passengerInformation");

    const formData = new FormData();
    const pickLocation = location.find(
      (item) => item.id === values.pick_location
    );
    const dropLocation = location.find(
      (item) => item.id === values.drop_location
    );

    if (!pickLocation?.id && !dropLocation?.id) {
      toast.error(
        "Please select your pick up point and Please select your destination"
      );
      return;
    } else if (pickLocation?.id === dropLocation?.id) {
      toast.error("Boarding point and destination must not be the same");
      return;
    } else if (!pickLocation?.id) {
      toast.error("Please select your pick up point");
      return;
    } else if (!dropLocation?.id) {
      toast.error("Please select your destination");
      return;
    } else if (!journeyStartDate) {
      toast.error("Please select your journey date");
      return;
    }

    formData.append("pick_location_id", pickLocation?.id);
    formData.append("drop_location_id", dropLocation?.id);
    formData.append("journeydate", dateForm(journeyStartDate));

    const searchInfo = {
      pickLocation: pickLocation?.id,
      dropLocation: dropLocation?.id,
      journeydate: dateForm(journeyStartDate),
      returnDate: dateForm(journeyReturnDate),
    };

    dispatch(SearchInfoStore(searchInfo));
    dispatch(setJourneyDepartureDate(journeyStartDate));
    localStorage.setItem("searchInfo", JSON.stringify(searchInfo));

    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/triplist`,
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (result.status === "success") {
      dispatch(addBusName(result.data));

      setFilterBus(result.data);
      history.push("/booking");
    } else {
      dispatch(addBusName(null));

      toast.error(`${result?.message}`);
    }
  };

  useEffect(() => {
    if (searchInfo?.journeydate) {
      const incomingDate = new window.Date(searchInfo?.journeydate);
      setJourneyStartDate(incomingDate);
    } else if (journeyStartDate === "") {
      setJourneyStartDate(new window.Date());
    }
  }, [searchInfo]);

  const primaryColor = webSettingData?.buttoncolor || '#1FBA30';
  const primaryHoverColor = webSettingData?.buttoncolorhover || '#1aa329';
  const textColor = webSettingData?.buttontextcolor || 'white';

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {!isHome ? (
          // For Home Page
          <>
            <TabContainer>
              <TabItem active={activeTab === "bus"} activeColor={primaryColor} onClick={() => setActiveTab("bus")}>
                <BusIcon /> Bus
              </TabItem>
              <TabItem active={activeTab === "launch"} activeColor={primaryColor} onClick={() => toast.info("Launch booking coming soon!")}>
                <ShipIcon /> Launch
              </TabItem>
              <TabItem active={activeTab === "flight"} activeColor={primaryColor} onClick={() => toast.info("Flight booking coming soon!")}>
                <FlightIcon /> Flight
              </TabItem>
            </TabContainer>

            <InnerForm>
              <InputsRow>
                <Location>
                  <InputGroup focusColor={primaryColor}>
                    <InputLabel>Depart From</InputLabel>
                    <SearchLocation
                      styles={cursorStyles}
                      placeholder={
                        languageData?.search_form_from_input[
                          webSettingData?.language
                        ] || "Select Boarding Point"
                      }
                      options={pickLocation}
                      value={pickLocation[getPicLocation(pickLocation, values)]}
                      onChange={handleBoardingChange}
                      ref={locationRef}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </InputGroup>

                  <ExchangeButton color={primaryColor} onClick={handleExchange} title="Swap Locations">
                    <svg viewBox="0 0 24 24" width="16" height="16">
                      <path d="M19 8l-4 4h3v6h-6v2h8V8h-1zm-6-2H5v12h1l4-4H7V8h6V6z" />
                    </svg>
                  </ExchangeButton>

                  <InputGroup focusColor={primaryColor}>
                    <InputLabel>Going To</InputLabel>
                    <SearchLocation
                      styles={cursorStyles}
                      placeholder={
                        languageData?.search_form_to_input[
                          webSettingData?.language
                        ] || "Select Destination"
                      }
                      options={dropLocation}
                      value={dropLocation[getDropLocation(dropLocation, values)]}
                      onChange={handleDroppingChange}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </InputGroup>
                </Location>

                <DateContainer>
                  <InputGroup focusColor={primaryColor}>
                    <InputLabel>Journey Date</InputLabel>
                    <Calendar
                      onChange={startJourneyDateHandler}
                      value={journeyStartDate}
                      clearIcon={null}
                      dateFormat="MM/dd/yyyy"
                      minDate={moment().toDate()}
                    />
                  </InputGroup>

                  <InputGroup focusColor={primaryColor}>
                    <InputLabel>Return Date (Optional)</InputLabel>
                    <Calendar
                      onChange={returnJourneyDateHandler}
                      valueDefault={journeyStartDate}
                      value={journeyReturnDate}
                      clearIcon={null}
                      dateFormat="MM/dd/yyyy"
                      minDate={journeyStartDate}
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                    />
                  </InputGroup>
                </DateContainer>

                <SearchBtnArea>
                  {languageData?.search_form_button ? (
                    <SearchBtn
                      searchbtnbgcolor={primaryColor}
                      searchbtnbghvcolor={primaryHoverColor}
                      btntextcolor={textColor}
                      type="submit"
                    >
                      <SearchIcon />
                      <span style={{ display: "none" }}>Search</span>
                    </SearchBtn>
                  ) : (
                    ""
                  )}
                </SearchBtnArea>
              </InputsRow>

              <TrendingWrapper color={primaryColor}>
                <span className="title">Trending Searches:</span>
                <span className="route" onClick={() => handleTrendingSearch("Dhaka", "Cox's Bazar")}>Dhaka ➔ Cox's Bazar</span>
                <span className="route" onClick={() => handleTrendingSearch("Dhaka", "Rajshahi")}>Dhaka ➔ Rajshahi</span>
                <span className="route" onClick={() => handleTrendingSearch("Chittagong", "Cox's Bazar")}>Chittagong ➔ Cox's Bazar</span>
                <span className="route" onClick={() => handleTrendingSearch("Dhaka", "Sylhet")}>Dhaka ➔ Sylhet</span>
              </TrendingWrapper>
            </InnerForm>
          </>
        ) : (
          // For Booking Page (compact layout)
          <BookingPageInnerForm>
            <BookingPageLocation>
              <InputGroup focusColor={primaryColor}>
                <InputLabel>Depart From</InputLabel>
                <SearchLocation
                  styles={cursorStyles}
                  placeholder={
                    languageData?.search_form_from_input[
                      webSettingData?.language
                    ] || "Select Boarding Point"
                  }
                  options={pickLocation}
                  value={pickLocation[getPicLocation(pickLocation, values)]}
                  onChange={handleBoardingChange}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                />
              </InputGroup>

              <ExchangeButton color={primaryColor} onClick={handleExchange} title="Swap Locations" style={{ top: '50%' }}>
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path d="M19 8l-4 4h3v6h-6v2h8V8h-1zm-6-2H5v12h1l4-4H7V8h6V6z" />
                </svg>
              </ExchangeButton>

              <InputGroup focusColor={primaryColor}>
                <InputLabel>Going To</InputLabel>
                <SearchLocation
                  styles={cursorStyles}
                  placeholder={
                    languageData?.search_form_to_input[
                      webSettingData?.language
                    ] || "Select Destination"
                  }
                  options={dropLocation}
                  value={dropLocation[getDropLocation(dropLocation, values)]}
                  onChange={handleDroppingChange}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                />
              </InputGroup>
            </BookingPageLocation>

            <BookingPageDate>
              <InputGroup focusColor={primaryColor}>
                <InputLabel>Depart Date</InputLabel>
                <Calendar
                  onChange={startJourneyDateHandler}
                  value={journeyStartDate}
                  clearIcon={null}
                  dateFormat="MM/dd/yyyy"
                  minDate={moment().toDate()}
                />
              </InputGroup>
              <InputGroup focusColor={primaryColor}>
                <InputLabel>Return Date</InputLabel>
                <Calendar
                  onChange={returnJourneyDateHandler}
                  value={journeyReturnDate}
                  clearIcon={null}
                  dateFormat="MM/dd/yyyy"
                  minDate={journeyStartDate}
                  valueDefault={null}
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
              </InputGroup>
            </BookingPageDate>

            <BookingPageSearchBtn
              searchbtnbgcolor={primaryColor}
              searchbtnbghvcolor={primaryHoverColor}
              btntextcolor={textColor}
              type="submit"
            >
              <SearchIcon />
            </BookingPageSearchBtn>
          </BookingPageInnerForm>
        )}
      </Form>
    </>
  );
};

export default SearchForm;
